export { default as AssetsMenuModal } from './component';
